module.exports = __webpack_public_path__ + "static/10.1-84fd047b6393de4b3c7c688716ba2d12.jpg";